export const siteConfig = {
  name: "ChitraDev",
  tagline: "Unlimited local image generation on your own machine.",
  description:
    "A local FastAPI app for prompt-only Stable Diffusion 1.5 generation with optional IP-Adapter FaceID identity guidance, no hosted quotas, and no repo-imposed creative category blocks.",
  githubUrl: "https://github.com/yuvrajraina/ChitraDev",
  frontendGithubUrl: "https://github.com/yuvrajraina/ChitraDevWeb",
  docsUrl: "#docs",
  heroImage:
    "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1800&q=85",
  canonicalUrl: "https://yuvrajraina.github.io/ChitraDevWeb/"
};
